(function () {
  'use strict';

  /* @ngdoc object
   * @name urlShorteners
   * @description
   *
   */
  angular
    .module('urlShorteners', []);
}());
